import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "banner_container" }
const _hoisted_2 = ["src"]

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Swiper as SwiperType, Autoplay, Pagination } from 'swiper'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { computed, onActivated, ref, onDeactivated } from 'vue'
import { useThemeColor } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { handleExternalUrl } from '@/utils/navigation'

interface TSwiperItem {
  dataJumpType: number
  dataJumpUrl: string
  dataJumpId: string
  dataJumpName: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Banner',
  props: {
    data: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "5596a427": (_unref(themeColor))
}))

const props = __props

const swiperInstance = ref()
const setSwiper = (swiper: SwiperType) => {
  swiperInstance.value = swiper
}
onDeactivated(() => {
  swiperInstance.value.autoplay.pause()
})
onActivated(() => {
  swiperInstance.value.autoplay.start()
})

const router = useRouter()
const skipHandle = (item: TSwiperItem) => {
  switch (item.dataJumpType) {
    case 1: // 课程
      router.push({
        name: 'courseDetail',
        query: {
          id: item.dataJumpId,
          courseId: '',
          endingType: 0,
          channel: 1,
          courseType: 'course'
        }
      })
      break
    case 2: // 课件
      router.push({
        name: 'courseDetail',
        query: {
          id: item.dataJumpId,
          courseId: '',
          endingType: 0,
          channel: 1,
          courseType: 'courseWare'
        }
      })
      break
    case 3: // 链接
      // router.push('/webview?url=' + encodeURIComponent(item.dataJumpUrl))
      handleExternalUrl({ jumpUrl: item.dataJumpUrl })
      break
    case 4: // 资讯
      router.push('/broadcastDetail/' + item.dataJumpId)
      break
    case 5: // 培训
      router.push('/trainingDetail?id=' + item.dataJumpId)
      break
    case 6: // 考试
      router.push('/examInfo?examId=' + item.dataJumpId)
      break
    case 7: // 调查
      router.push('/surveyInfo?investigationId=' + item.dataJumpId)
      break
    case 8: // 直通车
      router.push('/ceo')
      break
    default:
      break
  }
}

const modules = [Autoplay, Pagination]
const swiperData = computed(() => {
  try {
    // console.log(JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})
const type = computed(() => {
  try {
    return JSON.parse(props.data.extendInfo).type
  } catch (error) {
    return {}
  }
})

const themeColor = useThemeColor()
const pagination = {
  clickable: true,
  renderBullet(index: number, className: string) {
    return '<span class="' + className + '"></span>'
  }
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Swiper), {
      modules: modules,
      slidesPerView: type.value === 'card_slide' ? 1.2 : 1,
      centeredSlides: true,
      loop: "",
      autoplay: {
        disableOnInteraction: false
      },
      spaceBetween: type.value === 'card_slide' ? 15 : 0,
      class: _normalizeClass(["banner_wrapper", { banner_wrapper_full: type.value === 'tile', banner_wrapper1: type.value === 'card_slide' }]),
      pagination: pagination,
      onSwiper: setSwiper
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(swiperData.value, (item, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index,
            onClick: ($event: any) => (skipHandle(item))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: item.dataImgUrl,
                class: "banner_img"
              }, null, 8, _hoisted_2)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["slidesPerView", "spaceBetween", "class"])
  ], 512)), [
    [_vShow, swiperData.value && swiperData.value.length > 0]
  ])
}
}

})